import React from 'react';
import { MultiFormatWriter, EncodeHintType, BarcodeFormat } from '@zxing/library';
import StringBuilder from "@zxing/library/esm/core/util/StringBuilder";

const SVG_NS = 'http://www.w3.org/2000/svg'
const QUIET_ZONE_SIZE = 0;


const getQR = (data, w, h) => {
  const hints = new Map();
  const formats = [BarcodeFormat.QR_CODE];

  hints.set(EncodeHintType.POSSIBLE_FORMATS, formats);
  const writer = new MultiFormatWriter();
  
  hints.set(EncodeHintType.MARGIN, QUIET_ZONE_SIZE);

  var inputWidth = w;
  var inputHeight = h;
  var qrWidth = inputWidth + (QUIET_ZONE_SIZE * 2);
  var qrHeight = inputHeight + (QUIET_ZONE_SIZE * 2);
  var outputWidth = Math.max(w, qrWidth);
  var outputHeight = Math.max(h, qrHeight);
  var multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
  var leftPadding = Math.floor((outputWidth - (inputWidth * multiple)) / 2);
  var topPadding = Math.floor((outputHeight - (inputHeight * multiple)) / 2);

  const qr = writer.encode(data, BarcodeFormat.QR_CODE, outputWidth, outputHeight, hints)
  let sbPath = new StringBuilder();
  for (var inputY = 0, outputY = topPadding; inputY < qr.getWidth(); inputY++, outputY += multiple) {
    for (var inputX = 0, outputX = leftPadding; inputX < qr.getHeight(); inputX++, outputX += multiple) {
      if (qr.get(inputX, inputY)) {
        let w = createSvgRectElement(inputX, inputY, multiple, multiple)
        sbPath.append(`${w.outerHTML}`)
      }
    }
  }
  let sb = new StringBuilder();
  sb.append(`<svg xmlns="http://www.w3.org/2000/svg" width="${w}px" height="${h}px">`);
  sb.append(`<g>`)
  sb.append(`${sbPath}`)
  sb.append(`</g>`)

  sb.append(`</svg>`);
  return <div dangerouslySetInnerHTML={{ __html: sb }} />
}


const createSvgRectElement = (x, y, w, h) => {
  var rect = document.createElementNS(SVG_NS, 'rect');
  rect.setAttributeNS(null, 'x', x.toString());
  rect.setAttributeNS(null, 'y', y.toString());
  rect.setAttributeNS(null, 'height', w.toString());
  rect.setAttributeNS(null, 'width', h.toString());
  rect.setAttributeNS(null, 'fill', '#000000');
  return rect;
}

export {
  getQR,
}


